export function faqPageJsonLd(faqs) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map(({ q, a }) => ({
      '@type': 'Question',
      name: q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: a
      }
    }))
  };
}

export function setFaqJsonLd(faqs) {
  const existing = document.getElementById('faq-json-ld');
  if (!faqs?.length) {
    existing?.remove();
    return;
  }

  const script = existing || document.createElement('script');
  script.id = 'faq-json-ld';
  script.type = 'application/ld+json';
  script.textContent = JSON.stringify(faqPageJsonLd(faqs));
  if (!existing) document.head.appendChild(script);
}
